var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/08f642757d881febcd616cad1674a8f7.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1ac600918e53fb798e73254239d66e03.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2ec02dfff7e2b18cfe979331958a2d00.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32d95156e435e17bbceb59cc45e7cc36.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4584fddddac8f002733200fad4d74f0a.js').default;
var scope_5 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48630d5ee05231b5a0e0725e07ee230d.js').default;
var scope_6 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63e50d855140533d48a72a12a82c4244.js').default;
var scope_7 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6fafe968558ff5b7f28a1348e390b6d0.js').default;
var scope_8 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76d738a9ae59496eb647f44661574524.js').default;
var scope_9 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8f4dae27ec3a656a6cabc559fe729ed4.js').default;
var scope_10 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9bdebf7f788110e847c84ed4ef4eb99d.js').default;
var scope_11 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a75d77ae63ac4e560ae63c126209e22e.js').default;
var scope_12 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad33f1956af2c7c6b1430e8e274c536b.js').default;
var scope_13 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b53dcee8b1c2c7eb07ccd4d4bc2adb94.js').default;
var scope_14 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c67a186b50feef41eaf063f69e55d775.js').default;
var scope_15 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/da84b16abc040a0b9e3ce33c6c0a5931.js').default;
var scope_16 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/decc15b75ad916dd3a9a7872ed045da4.js').default;
var scope_17 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e2cbe38dd7ec19fbb22ea4b118b3f01d.js').default;
var scope_18 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_19 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fbe5bf6a887f2f482878cabb59593d3a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19 )
    